import { useCart } from "apps/vtex/hooks/useCart.ts";
import { formatPrice } from "$store/sdk/format.ts";
import ShippingSimulation from "$store/islands/header/minicart/ShippingSimulation.tsx";
import { sendEvent } from "$store/sdk/analytics.tsx";

export default function Totalizers() {
  const { cart, loading, mapItemsToAnalyticsItems } = useCart();
  const totalizers = cart.value?.totalizers;
  const locale = cart.value?.clientPreferencesData.locale;
  const currencyCode = cart.value?.storePreferencesData.currencyCode;
  const total = totalizers?.find((item) => item.id === "Items")?.value || 0;
  const discounts =
    totalizers?.find((item) => item.id === "Discounts")?.value || 0;
  const totalItems = cart.value?.items.length ?? 0;

  if (cart.value === null || !totalItems) return null;

  return (
    <footer class="px-4 pt-3 pb-6 bg-tw-base-100 bg-opacity-30 lg:max-2xl:pb-3">
      <div class="text-tw-neutral-600 text-sm flex justify-between items-center lg:max-2xl:text-xs">
        <span class="font-bold">Quantidade:</span>
        <span>
          {totalItems.toString().padStart(2, "0")}{" "}
          {totalItems > 1 ? "itens" : "item"}
        </span>
      </div>

      <ShippingSimulation />

      <div class="mt-2 mb-4 text-tw-neutral-600 text-lg font-bold flex justify-between items-center lg:max-2xl:text-base">
        <span class="font-bold">Subtotal:</span>
        <span>
          {total
            ? formatPrice(
              (total / 100) + (discounts / 100),
              currencyCode!,
              locale,
            )
            : ""}
        </span>
      </div>

      <a class="inline-block w-full" href="/checkout">
        <button
          data-deco="buy-button"
          class="w-full h-12 rounded-lg bg-tw-success-200 text-white text-xl font-bold lg:max-2xl:h-10 lg:max-2xl:text-base"
          disabled={loading.value || cart.value.items.length === 0}
          onClick={() => {
            sendEvent({
              name: "begin_checkout",
              params: {
                currency: cart.value ? currencyCode! : "",
                value: (total - discounts) / 100,
                coupon: cart.value?.marketingData?.coupon ?? undefined,
                items: cart.value ? mapItemsToAnalyticsItems(cart.value) : [],
              },
            });
          }}
        >
          Finalizar Compra
        </button>
      </a>

      <label
        class="w-max mx-auto mt-2 text-tw-neutral-400 text-lg text-center font-semibold underline block cursor-pointer lg:max-2xl:text-sm"
        htmlFor="minicart-drawer"
      >
        Continuar comprando
      </label>
    </footer>
  );
}
